export const labels = {
  is: 'Íslenska',
  no: 'Norska',
  pl: 'Pólska',
  en: 'Enska',
  ar: 'Arabíska',
  es: 'Spænska',
  pt: 'Portúgalska',
  ru: 'Rússneska',
};
export const languageCodes = ['is', 'no', 'pl', 'en', 'ar', 'es', 'pt', 'ru'] as const;
export const isInterpreterLanguage = (value: unknown): value is (typeof languageCodes)[number] =>
  languageCodes.some((language) => language === value);
export const phases = {
  speaking: 'Talaðu núna',
  processing: 'Þýði og undirbý upplestur',
  playback: 'Upplestur',
  paused: 'Í hléi',
  failed: 'Vinnsla stöðvaðist',
  ended: 'Viðtali lokið',
};
